import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from "@/components/ui/dialog";
import { X } from "lucide-react";

type InfoModalProps = {
  title: string;
  content: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
};

const InfoModal = ({ title, content, isOpen, onClose }: InfoModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="glass border-datavidya-purple max-h-[80vh] overflow-y-auto">
        <DialogClose asChild>
          <button
            className="absolute right-4 top-4 flex items-center justify-center w-8 h-8 rounded-full bg-black/40 border border-white/20 text-gray-300 hover:text-white hover:bg-black/60 transition focus:outline-none"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </DialogClose>
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center text-gradient">
            {title}
          </DialogTitle>
        </DialogHeader>
        <div className="text-gray-300 mt-4">{content}</div>
      </DialogContent>
    </Dialog>
  );
};

export default InfoModal;
